import { api, apiArquivos, apiReports } from '@services/api'
import axios from 'axios'
import { trackPromise } from 'react-promise-tracker'

let requestUsuarioPermissoes = null
let requestBancos = null
let reqListarCartoes = null
let reqAtualizarContaBancaria = null
let reqListarContasBancarias = null
let reqEstabelecimentos = null
let reqParametros = null
let reqListarDocumentos = null
let requestArquivosDownload = null
let requestRemoverArquivoDisco = null
let requestArquivosVincular = null
let reqAtualizarAcordo = null
let reqBandeirasPorAdquirentes = null
let reqInformeRendimentos = null
/* Transações */
let reqSimularVendas = null
let reqListarInternacionais = null
let reqTransacoes = null
let reqTransacoesPorEC = null
let reqTransacoesPorDistribuidor = null
let reqParcelasDaTransacao = null
/* Cancelamentos */
let reqListarCancelamentos = null
let reqCancelamentosBaixar = null
/* Chargebacks */
let reqListarChargebacks = null
/* Antecipacoes */
let reqRelatorioAntecipacoes = null
let reqRelatorioTransacoes = null
let reqRelatorioTransacoesPorEC = null
/* Estabelecimentos */
let reqCadastraEC = null
let reqVisualizarEstabelecimento = null
let reqAtualizarEstabelecimento = null
let reqRelatorioEstabelecimento = null
let reqListaCarteira = null
let requestLancamentosEstabelecimento = null
let reqListaCapturas = null
let requestPesquisaRecebiveis = null
let reqListarDepartamentos = null
let reqListaDispositivos = null
let reqListaContatos = null
let reqBuscaEnderecos = null
/* Planos Comerciais */
let reqBuscarEstabelecimentos = null
let reqPesquisaEstabelecimentos = null
let reqEstabelecimentosPlanos = null
let reqEstabelecimentosPlanosAtualizar = null
let reqAtualizarEstabelecimentoPlano = null
let reqEstabelecimentosPlanosCadastrar = null
let reqEstabelecimentosPlanosRemover = null
let reqListaAdquirentes = null
let reqAcordoComercial = null
/* Regras de Divisão */
let reqListarRegrasDivisao = null
let reqAdicionarRegrasDivisao = null
let reqAtualizarRegrasDivisao = null
let reqExcluirRegrasDivisao = null
/* Dispositivos */
let reqPesquisaFabricante = null
let reqListaNumeroLogico = null
/* Transferências */
let requestTransferenciaResumo = null
let requestTransferenciaLiquidacaoBanco = null
let requestTransferenciaRetornoBanco = null
let requestLotesPagamentosConsulta = null
/* Transferências */
let reqVisualizarTransferencia = null
let reqListarTransferencias = null
let reqResumoTransferencias = null
/* Financeiro */
let reqListarPagamentos = null
/* Fluxo de Caixa */
let reqContasReceberAJ = null
let reqContasPagarAJ = null
let reqContasReceberPagar = null
let reqAnaliseRAV = null
let reqAnalisePR = null
let reqAnaliseMDR = null
/* Dashboard */
let reqResumoVendas = null
let reqResumoBandeiras = null
let reqResumoPeriodo = null
let reqResumoVendasEc = null
/* Login */
let reqSolicitarAlteracaoSenha = null
let reqAlterarSenhaAcesso = null
let reqValidarTokenRecuperacao = null

let requestBuscaEndereco = null

/* Relatórios API Arquivos */
let requestSolicitarRelatorio = null
let requestApiReports = null
let requestRelatoriosSolicitados = null

/* ------------------------------------ Login ------------------------------------- */

export const SolicitarAlteracaoSenha = async (parametros) => {
  if (reqSolicitarAlteracaoSenha !== null || parametros !== undefined) {
    if (reqSolicitarAlteracaoSenha !== null) reqSolicitarAlteracaoSenha();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.post('/v1/recuperar-senha', {
      cancelToken: new CancelToken(function executor(c) {
        reqSolicitarAlteracaoSenha = c;
      }),
      email: parametros.email
    })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno
}

export const UsuarioPermissoes = async parametros => {
	if (requestUsuarioPermissoes !== null || parametros !== undefined) {
		if (requestUsuarioPermissoes !== null) requestUsuarioPermissoes();
		if (parametros.cancelar) {
			requestUsuarioPermissoes = null; // Limpar a referência
			return 0;
		}
	}

	var CancelToken = axios.CancelToken;
	var retorno = '';

	await trackPromise(
		api.get('v1/usuarios/permissoes', {
				cancelToken: new CancelToken(function executor(c) {
					requestUsuarioPermissoes = c;
				}),
				params: parametros
			})
			.then(response => {
				requestUsuarioPermissoes = null; // Limpar após sucesso
				retorno = response;
			})
			.catch(error => {
				requestUsuarioPermissoes = null; // Limpar após erro
				retorno = error.response;
			})
	);

	return retorno;
};

export const LotesPagamentosConsulta = async (parametros) => {

  if (requestLotesPagamentosConsulta !== null || parametros !== undefined) {
    if (requestLotesPagamentosConsulta !== null) requestLotesPagamentosConsulta();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/lotes", {
      cancelToken: new CancelToken(function executor(c) {
        requestLotesPagamentosConsulta = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

export const AlterarSenhaAcesso = async (parametros) => {
  if (reqAlterarSenhaAcesso !== null || parametros !== undefined) {
    if (reqAlterarSenhaAcesso !== null) reqAlterarSenhaAcesso();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.post('v1/recuperar-senha/confirmar', {
      cancelToken: new CancelToken(function executor(c) {
        reqAlterarSenhaAcesso = c;
      }),
      token: parametros.token,
      password: parametros.password
    })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno;
}

export const TransferenciaLiquidacaoBanco = async (parametros) => {

  if (requestTransferenciaLiquidacaoBanco !== null || parametros !== undefined) {
    if (requestTransferenciaLiquidacaoBanco !== null) requestTransferenciaLiquidacaoBanco();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/transferencias/relatorios/bancos", {
      cancelToken: new CancelToken(function executor(c) {
        requestTransferenciaLiquidacaoBanco = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

export const ValidarTokenRecuperacao = async (parametros) => {
  if (reqValidarTokenRecuperacao !== null || parametros !== undefined) {
    if (reqValidarTokenRecuperacao !== null) reqValidarTokenRecuperacao();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.post('v1/recuperar-senha/validar', {
      cancelToken: new CancelToken(function executor(c) {
        reqValidarTokenRecuperacao = c;
      }),
      token: parametros.token
    })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno;
}

/* ------------------------------------ Dashboard ------------------------------------- */
export const ResumoVendas = async parametros => {
  if (reqResumoVendas !== null || parametros !== undefined) {
    if (reqResumoVendas !== null) reqResumoVendas()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/transacoes/resumo', {
        cancelToken: new CancelToken(function executor(c) {
          reqResumoVendas = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      }
      )
      .catch(error => {
        retorno = error.response
      })
  )
  return retorno
}

export const ResumoBandeiras = async parametros => {
  if (reqResumoBandeiras !== null || parametros !== undefined) {
    if (reqResumoBandeiras !== null) reqResumoBandeiras()
    if (parametros.cancelar) return 0
  }
  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/transacoes/resumo/bandeiras', {
        cancelToken: new CancelToken(function executor(c) {
          reqResumoBandeiras = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      }
      )
      .catch(error => {
        retorno = error.response
      })
  )
  return retorno
}

export const ResumoPeriodo = async parametros => {
  if (reqResumoPeriodo !== null || parametros !== undefined) {
    if (reqResumoPeriodo !== null) reqResumoPeriodo()
    if (parametros.cancelar) return 0
  }
  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/transacoes/resumo/periodo', {
        cancelToken: new CancelToken(function executor(c) {
          reqResumoPeriodo = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      }
      )
      .catch(error => {
        retorno = error.response
      })
  )
  return retorno
}

export const ResumoVendasEc = async parametros => {
  if (reqResumoVendasEc !== null || parametros !== undefined) {
    if (reqResumoVendasEc !== null) reqResumoVendasEc()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/transacoes/resumo/estabelecimentos', {
        cancelToken: new CancelToken(function executor(c) {
          reqResumoVendasEc = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )
  return retorno
}

export const ListarBancos = async parametros => {
  if (requestBancos !== null || parametros !== undefined) {
    if (requestBancos !== null) requestBancos()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/bancos', {
        cancelToken: new CancelToken(function executor(c) {
          requestBancos = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const TransferenciaRetornoBanco = async (parametros) => {

  if (requestTransferenciaRetornoBanco !== null || parametros !== undefined) {
    if (requestTransferenciaRetornoBanco !== null) requestTransferenciaRetornoBanco();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/transferencias/relatorios/retornos", {
      cancelToken: new CancelToken(function executor(c) {
        requestTransferenciaRetornoBanco = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

export const CadastrarContaBancaria = async (parametros) => {
  if (reqEstabelecimentosPlanosCadastrar !== null || parametros !== undefined) {
    if (reqEstabelecimentosPlanosCadastrar !== null) reqEstabelecimentosPlanosCadastrar()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .post('/v1/conta-bancaria/cadastrar', {
        cancelToken: new CancelToken(function executor(c) {
          reqEstabelecimentosPlanosCadastrar = c
        }),
        codigoEC: parametros.codigoEC,
        codigoBanco: parametros.codigoBanco,
        favorecido: parametros.favorecido,
        cpfCnpj: parametros.cpfCnpj,
        tipo_conta: parametros.tipo_conta,
        percentual: parametros.percentual,
        tarifa: parametros.tarifa,
        agencia: parametros.agencia,
        agencia_digito: parametros.agencia_digito,
        conta: parametros.conta,
        conta_digito: parametros.conta_digito,
        situacao: parametros.situacao,
        verificado: parametros.verificado,
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const AtualizarContaBancaria = async (parametros) => {

  if (reqAtualizarContaBancaria !== null || parametros !== undefined) {
    if (reqAtualizarContaBancaria !== null) reqAtualizarContaBancaria();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api
      .put("/v1/conta-bancaria/atualizar", {
        cancelToken: new CancelToken(function executor(c) {
          reqAtualizarContaBancaria = c;
        }),
        codigoConta: parametros.codigoEC,
        situacao: parametros.transferenciaAutomatica,
      }).then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

export const ListarContasBancarias = async parametros => {
  if (reqListarContasBancarias !== null || parametros !== undefined) {
    if (reqListarContasBancarias !== null) reqListarContasBancarias()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/conta-bancaria', {
        cancelToken: new CancelToken(function executor(c) {
          reqListarContasBancarias = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const ListarCartoes = async parametros => {
  if (reqListarCartoes !== null || parametros !== undefined) {
    if (reqListarCartoes !== null) reqListarCartoes()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/cartoes', {
        cancelToken: new CancelToken(function executor(c) {
          reqListarCartoes = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const ListarClientes = async parametros => {
  if (reqEstabelecimentos !== null || parametros !== undefined) {
    if (reqEstabelecimentos !== null) reqEstabelecimentos()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/estabelecimentos/?busca=' + parametros.cliente, {
        cancelToken: new CancelToken(function executor(c) {
          reqEstabelecimentos = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const cadastraEC = async parametros => {
  if (reqCadastraEC !== null || parametros !== undefined) {
    if (reqCadastraEC !== null) reqCadastraEC()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  let retorno = ''

  await trackPromise(
    api
      .post('v1/estabelecimentos/credenciamento', {
        cancelToken: new CancelToken(function executor(c) {
          reqCadastraEC = c
        }),
        credenciamentos: parametros.credenciamentos
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const AtualizarLogo = async (params) => {
  let retorno

  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }

  await trackPromise(
    api.post('v1/parametros/logo-upload?produto=' + params.produto, params.arquivo, config)
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno
}

export const AtualizarParametros = async (params) => {
  let retorno

  await trackPromise(
    api.post('v1/parametros/atualizar', params)
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno
}

export const ListarDepartamentos = async (parametros) => {
  if (reqListarDepartamentos !== null || parametros !== undefined) {
    if (reqListarDepartamentos !== null) reqListarDepartamentos()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/departamentos', {
        cancelToken: new CancelToken(function executor(c) {
          reqListarDepartamentos = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}


export const ListarDocumentos = async (parametros) => {

  if (reqListarDocumentos !== null || parametros !== undefined) {
    if (reqListarDocumentos !== null) reqListarDocumentos();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/arquivos", {
      cancelToken: new CancelToken(function executor(c) {
        reqListarDocumentos = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

export const arquivosDownload = async (parametros) => {

  if (requestArquivosDownload !== null || parametros !== undefined) {
    if (requestArquivosDownload !== null) requestArquivosDownload();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/arquivos/download", {
      cancelToken: new CancelToken(function executor(c) {
        requestArquivosDownload = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

export const removerArquivoDisco = async (parametros) => {

  if (requestRemoverArquivoDisco !== null || parametros !== undefined) {
    if (requestRemoverArquivoDisco !== null) requestRemoverArquivoDisco();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.delete("/v1/arquivos", {
      cancelToken: new CancelToken(function executor(c) {
        requestRemoverArquivoDisco = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

export const arquivosVincular = async (parametros) => {

  if (requestArquivosVincular !== null || parametros !== undefined) {
    if (requestArquivosVincular !== null) requestArquivosVincular();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.put("/v1/arquivos/vincular", {
      cancelToken: new CancelToken(function executor(c) {
        requestArquivosVincular = c;
      }),
      codigoEC: parametros.codigoEC,
      documentos: parametros.documentos
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

export const listaNumeroLogico = async (parametros) => {

  if (reqListaNumeroLogico !== null || parametros !== undefined) {
    if (reqListaNumeroLogico !== null) reqListaNumeroLogico();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/numero-logico", {
      cancelToken: new CancelToken(function executor(c) {
        reqListaNumeroLogico = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno
}

export const cadastrarNumerosLogicos = async (parametros) => {

  if (reqListaNumeroLogico !== null || parametros !== undefined) {
    if (reqListaNumeroLogico !== null) reqListaNumeroLogico();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.post("/", {
      cancelToken: new CancelToken(function executor(c) {
        reqListaNumeroLogico = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno
}

export const listaSimCards = async (parametros) => {

  if (reqListaNumeroLogico !== null || parametros !== undefined) {
    if (reqListaNumeroLogico !== null) reqListaNumeroLogico();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/", {
      cancelToken: new CancelToken(function executor(c) {
        reqListaNumeroLogico = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno
}

export const pesquisaFabricante = async (parametros) => {

  if (reqPesquisaFabricante !== null || parametros !== undefined) {
    if (reqPesquisaFabricante !== null) reqPesquisaFabricante();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/dispositivos/fabricantes", {
      cancelToken: new CancelToken(function executor(c) {
        reqPesquisaFabricante = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

export const cadastrarDispositivos = async (parametros) => {

  if (requestArquivosVincular !== null || parametros !== undefined) {
    if (requestArquivosVincular !== null) requestArquivosVincular();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1", {
      cancelToken: new CancelToken(function executor(c) {
        requestArquivosVincular = c;
      }),
      codigoEC: parametros.codigoEC,
      documentos: parametros.documentos
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

export const pesquisaModelo = async (parametros) => {

  if (requestArquivosVincular !== null || parametros !== undefined) {
    if (requestArquivosVincular !== null) requestArquivosVincular();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1", {
      cancelToken: new CancelToken(function executor(c) {
        requestArquivosVincular = c;
      }),
      codigoEC: parametros.codigoEC,
      documentos: parametros.documentos
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

export const AtualizarDispositivos = async (parametros) => {

  if (requestArquivosVincular !== null || parametros !== undefined) {
    if (requestArquivosVincular !== null) requestArquivosVincular();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.put("/v1", {
      cancelToken: new CancelToken(function executor(c) {
        requestArquivosVincular = c;
      }),
      codigoEC: parametros.codigoEC,
      documentos: parametros.documentos
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

/* ------------------------------------ /Chargebacks ------------------------------------- */

export const SimularVendas = async parametros => {
  if (reqSimularVendas !== null || parametros !== undefined) {
    if (reqSimularVendas !== null) reqSimularVendas()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/transacoes/simular-vendas', {
        cancelToken: new CancelToken(function executor(c) {
          reqSimularVendas = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const ListarInternacionais = async parametros => {
  if (reqListarInternacionais !== null || parametros !== undefined) {
    if (reqListarInternacionais !== null) reqListarInternacionais()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/transacoes', {
        cancelToken: new CancelToken(function executor(c) {
          reqListarInternacionais = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const Transacoes = async parametros => {
  if (reqTransacoes !== null || parametros !== undefined) {
    if (reqTransacoes !== null) reqTransacoes()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/transacoes', {
        cancelToken: new CancelToken(function executor(c) {
          reqTransacoes = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const TransacoesPorEC = async parametros => {
  if (reqTransacoesPorEC !== null || parametros !== undefined) {
    if (reqTransacoesPorEC !== null) reqTransacoesPorEC()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/transacoes/por-ecs', {
        cancelToken: new CancelToken(function executor(c) {
          reqTransacoesPorEC = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}


export const TransacoesPorDistribuidor = async parametros => {
  if (reqTransacoesPorDistribuidor !== null || parametros !== undefined) {
    if (reqTransacoesPorDistribuidor !== null) reqTransacoesPorDistribuidor()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/transacoes/por-distribuidor', {
        cancelToken: new CancelToken(function executor(c) {
          reqTransacoesPorDistribuidor = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const ParcelasDaTransacao = async parametros => {
  if (reqParcelasDaTransacao !== null || parametros !== undefined) {
    if (reqParcelasDaTransacao !== null) reqParcelasDaTransacao()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/transacoes/parcelas', {
        cancelToken: new CancelToken(function executor(c) {
          reqParcelasDaTransacao = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}


/* ------------------------------------ Cancelamentos/Chargebacks ------------------------------------- */

export const LancamentosHistorico = async parametros => {
  if (reqParametros !== null || parametros !== undefined) {
    if (reqParametros !== null) reqParametros()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/lancamentos/historico', {
        cancelToken: new CancelToken(function executor(c) {
          reqParametros = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

/* Cancelamentos */
export const ListarCancelamentos = async parametros => {
  if (reqListarCancelamentos !== null || parametros !== undefined) {
    if (reqListarCancelamentos !== null) reqListarCancelamentos()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/relatorios/cancelamentos', {
        cancelToken: new CancelToken(function executor(c) {
          reqListarCancelamentos = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const CancelamentosBaixar = async parametros => {
  if (reqCancelamentosBaixar !== null || parametros !== undefined) {
    if (reqCancelamentosBaixar !== null) reqCancelamentosBaixar()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/transacoes/cancelamentos/baixar', {
        cancelToken: new CancelToken(function executor(c) {
          reqCancelamentosBaixar = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

/* Chargebacks */
export const ListarChargebacks = async (parametros) => {
  if (reqListarChargebacks !== null || parametros !== undefined) {
    if (reqListarChargebacks !== null) reqListarChargebacks();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = "";

  await trackPromise(
    api
      .get("/v1/relatorios/chargebacks", {
        cancelToken: new CancelToken(function executor(c) {
          reqListarChargebacks = c;
        }),
      })
      .then((response) => {
        retorno = response
      })
      .catch((error) => {
        retorno = error.response;
      })
  );

  return retorno;
};

/* ------------------------------------ Estabelecimentos ------------------------------------- */
export const RelatorioEstabelecimento = async (parametros) => {
  if (reqRelatorioEstabelecimento !== null || parametros !== undefined) {
    if (reqRelatorioEstabelecimento !== null) reqRelatorioEstabelecimento()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/relatorios/faturamento', {
        cancelToken: new CancelToken(function executor(c) {
          reqRelatorioEstabelecimento = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const VisualizarEstabelecimento = async (parametros) => {
  if (reqVisualizarEstabelecimento !== null || parametros !== undefined) {
    if (reqVisualizarEstabelecimento !== null) reqVisualizarEstabelecimento()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/estabelecimentos/visualizar', {
        cancelToken: new CancelToken(function executor(c) {
          reqVisualizarEstabelecimento = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const AtualizarEstabelecimento = async (parametros) => {

  if (reqAtualizarEstabelecimento !== null || parametros !== undefined) {
    if (reqAtualizarEstabelecimento !== null) reqAtualizarEstabelecimento();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api
      .put("/v1/estabelecimentos/atualizar", {
        cancelToken: new CancelToken(function executor(c) {
          reqAtualizarEstabelecimento = c;
        }),
        codigoEC: parametros.codigoEC,
        transferenciaAutomatica: parametros.transferenciaAutomatica,
        periodicidade: parametros.periodicidade,
        valorMinimo: parametros.valorMinimo,
        situacao: parametros.situacao
      }).then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

export const ListaCarteira = async (parametros) => {
  if (reqListaCarteira !== null || parametros !== undefined) {
    if (reqListaCarteira !== null) reqListaCarteira()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/estabelecimentos/carteira', {
        cancelToken: new CancelToken(function executor(c) {
          reqListaCarteira = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}


export const LancamentosEstabelecimento = async (parametros) => {

  if (requestLancamentosEstabelecimento !== null || parametros !== undefined) {
    if (requestLancamentosEstabelecimento !== null) requestLancamentosEstabelecimento();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/lancamentos/estabelecimentos", {
      cancelToken: new CancelToken(function executor(c) {
        requestLancamentosEstabelecimento = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno
}

export const ListaCapturas = async (parametros) => {
  if (reqListaCapturas !== null || parametros !== undefined) {
    if (reqListaCapturas !== null) reqListaCapturas()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/parametros/capturas', {
        cancelToken: new CancelToken(function executor(c) {
          reqListaCapturas = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}



export const TransferenciaResumo = async (parametros) => {

  if (requestTransferenciaResumo !== null || parametros !== undefined) {
    if (requestTransferenciaResumo !== null) requestTransferenciaResumo();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/transferencias/resumo", {
      cancelToken: new CancelToken(function executor(c) {
        requestTransferenciaResumo = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}


export const pesquisaRecebiveis = async (parametros) => {

  if (requestPesquisaRecebiveis !== null || parametros.cancelar) {
    if (requestPesquisaRecebiveis !== null) requestPesquisaRecebiveis();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/parcelas/pesquisar", {
      cancelToken: new CancelToken(function executor(c) {
        requestPesquisaRecebiveis = c;
      }),
      params: parametros,
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

export const listaDispositivos = async (parametros) => {

  if (reqListaDispositivos !== null || parametros !== undefined) {
    if (reqListaDispositivos !== null) reqListaDispositivos();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/dispositivos", {
      cancelToken: new CancelToken(function executor(c) {
        reqListaDispositivos = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno
}

/* ------------------------------------ Planos Comerciais ------------------------------------- */

export const EstabelecimentosPlanos = async (parametros) => {
  if (reqEstabelecimentosPlanos !== null || parametros !== undefined) {
    if (reqEstabelecimentosPlanos !== null) reqEstabelecimentosPlanos()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/planos-ec/', {
        cancelToken: new CancelToken(function executor(c) {
          reqEstabelecimentosPlanos = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const EstabelecimentosPlanosAtualizar = async (parametros) => {
  if (reqEstabelecimentosPlanosAtualizar !== null || parametros !== undefined) {
    if (reqEstabelecimentosPlanosAtualizar !== null) reqEstabelecimentosPlanosAtualizar()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .put('/v1/planos-ec/atualizar', {
        cancelToken: new CancelToken(function executor(c) {
          reqEstabelecimentosPlanosAtualizar = c
        }),
        codigo_plano: parametros.codigo_plano,
        nome: parametros.nome,
        limite: parametros.limite,
        descricao: parametros.descricao,
        situacao: parametros.situacao
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const EstabelecimentosPlanosCadastrar = async (parametros) => {
  if (reqEstabelecimentosPlanosCadastrar !== null || parametros !== undefined) {
    if (reqEstabelecimentosPlanosCadastrar !== null) reqEstabelecimentosPlanosCadastrar()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .post('/v1/planos-ec/cadastrar', {
        cancelToken: new CancelToken(function executor(c) {
          reqEstabelecimentosPlanosCadastrar = c
        }),
        nome: parametros.nome,
        limite: parametros.limite,
        descricao: parametros.descricao,
        situacao: parametros.situacao
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const AtualizarEstabelecimentoPlano = async (parametros) => {
  if (reqAtualizarEstabelecimentoPlano !== null || parametros !== undefined) {
    if (reqAtualizarEstabelecimentoPlano !== null) reqAtualizarEstabelecimentoPlano()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .put('/v1/estabelecimentos/atualizar', {
        cancelToken: new CancelToken(function executor(c) {
          reqAtualizarEstabelecimentoPlano = c
        }),
        codigoEC: parametros.codigoEC,
        codigoPlano: parametros.codigoPlano
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const BuscarEstabelecimentos = async (parametros) => {
  if (reqBuscarEstabelecimentos !== null || parametros !== undefined) {
    if (reqBuscarEstabelecimentos !== null) BuscarEstabelecimentos()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/estabelecimentos', {
        cancelToken: new CancelToken(function executor(c) {
          reqBuscarEstabelecimentos = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )
  return retorno
}

export const PesquisaEstabelecimentos = async (parametros) => {
  if (reqPesquisaEstabelecimentos !== null || parametros !== undefined) {
    if (reqPesquisaEstabelecimentos !== null) reqPesquisaEstabelecimentos()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/estabelecimentos/buscar', {
        cancelToken: new CancelToken(function executor(c) {
          reqPesquisaEstabelecimentos = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const EstabelecimentosPlanosRemover = async (parametros) => {
  if (reqEstabelecimentosPlanosRemover !== null || parametros !== undefined) {
    if (reqEstabelecimentosPlanosRemover !== null) reqEstabelecimentosPlanosRemover()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .delete('/v1/planos-ec/excluir', {
        cancelToken: new CancelToken(function executor(c) {
          reqEstabelecimentosPlanosRemover = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

/* ------------------------------------ Regras de Divisão ------------------------------------- */

export const ListarRegrasDivisao = async (parametros) => {

  if (reqListarRegrasDivisao !== null || parametros !== undefined) {
    if (reqListarRegrasDivisao !== null) reqListarRegrasDivisao();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/regras-divisao", {
      cancelToken: new CancelToken(function executor(c) {
        reqListarRegrasDivisao = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno
}

export const AdicionarRegrasDivisao = async (parametros) => {

  if (reqAdicionarRegrasDivisao !== null || parametros !== undefined) {
    if (reqAdicionarRegrasDivisao !== null) reqAdicionarRegrasDivisao();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.post("/v1/regras-divisao/cadastrar", {
      cancelToken: new CancelToken(function executor(c) {
        reqAdicionarRegrasDivisao = c;
      }),
      codigo_estabelecimento: parametros.codigo_estabelecimento,
      codigo_recebedor: parametros.codigo_recebedor,
      hash: parametros.hash,
      numero_serie: parametros.numero_serie,
      dividir_custos: parametros.dividir_custos,
      risco_chargeback: parametros.risco_chargeback,
      percentual: parametros.percentual,
      valor: parametros.valor
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno
}

export const AtualizarRegrasDivisao = async (parametros) => {

  if (reqAtualizarRegrasDivisao !== null || parametros !== undefined) {
    if (reqAtualizarRegrasDivisao !== null) reqAtualizarRegrasDivisao();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.put("/v1/regras-divisao/alterar", {
      cancelToken: new CancelToken(function executor(c) {
        reqAtualizarRegrasDivisao = c;
      }),
      codigo_estabelecimento: parametros.codigo_estabelecimento,
      dividir_custos: parametros.dividir_custos,
      risco_chargeback: parametros.risco_chargeback,
      hash: parametros.hash,
      tipo_divisao: parametros.tipo_divisao,
      percentual: parametros.percentual,
      valor: parametros.valor,
      situacao: parametros.situacao,
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno
}

export const ExcluirRegrasDivisao = async (parametros) => {

  if (reqExcluirRegrasDivisao !== null || parametros !== undefined) {
    if (reqExcluirRegrasDivisao !== null) reqExcluirRegrasDivisao();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.delete("/v1/regras-divisao/excluir", {
      cancelToken: new CancelToken(function executor(c) {
        reqExcluirRegrasDivisao = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno
}
/* ------------------------------------ Endereços ------------------------------------- */
export const buscaEnderecos = async parametros => {
  if (reqBuscaEnderecos !== null || parametros !== undefined) {
    if (reqBuscaEnderecos !== null) reqBuscaEnderecos()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/enderecos', {
        cancelToken: new CancelToken(function executor(c) {
          reqBuscaEnderecos = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

/* ------------------------------------ Contatos ------------------------------------- */
export const buscaContatos = async parametros => {
  if (reqListaContatos !== null || parametros !== undefined) {
    if (reqListaContatos !== null) reqListaContatos()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/contatos', {
        cancelToken: new CancelToken(function executor(c) {
          reqListaContatos = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}
/* ------------------------------------ Acordo Comercial ------------------------------------- */

export const AcordoComercial = async (parametros) => {
  if (reqAcordoComercial !== null || parametros !== undefined) {
    if (reqAcordoComercial !== null) reqAcordoComercial()
    if (parametros.cancelar) return 0
  }

  var retorno = ''

  await trackPromise(
    api
      .get('/v1/acordos', {
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const AtualizarAcordo = async (parametros) => {
  if (reqAtualizarAcordo !== null || parametros !== undefined) {
    if (reqAtualizarAcordo !== null) reqAtualizarAcordo()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .post('/v1/acordos/solicitar/alteracao', {
        cancelToken: new CancelToken(function executor(c) {
          reqAtualizarAcordo = c
        }),
        codigoEC: parametros.codigoEC,
        codigoPlano: parametros.codigoPlano,
        codigoVendedor: parametros.codigoVendedor,
        codigoAdquirente: parametros.codigoAdquirente,
        codigoAdquirenteSftp: parametros.codigoAdquirenteSftp,
        bandeiras: parametros.bandeiras
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}


/* ------------------------------------ Adquirentes ------------------------------------- */

export const ListaAdquirentes = async (parametros) => {
  if (reqListaAdquirentes !== null || parametros !== undefined) {
    if (reqListaAdquirentes !== null) reqListaAdquirentes()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/adquirentes', {
        cancelToken: new CancelToken(function executor(c) {
          reqListaAdquirentes = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const BandeirasPorAdquirentes = async (parametros) => {
  if (reqBandeirasPorAdquirentes !== null || parametros !== undefined) {
    if (reqBandeirasPorAdquirentes !== null) reqBandeirasPorAdquirentes()
    if (parametros.cancelar) return 0
  }

  var retorno = ''

  await trackPromise(
    api
      .get('/v1/bandeiras/taxas', { params: parametros })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

/* ------------------------------------ Relatórios ------------------------------------- */

export const RelatorioAntecipacoes = async parametros => {
  if (reqRelatorioAntecipacoes !== null || parametros !== undefined) {
    if (reqRelatorioAntecipacoes !== null) reqRelatorioAntecipacoes()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/relatorios/antecipacoes', {
        cancelToken: new CancelToken(function executor(c) {
          reqRelatorioAntecipacoes = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const RelatorioTransacoes = async parametros => {
  if (reqRelatorioTransacoes !== null || parametros !== undefined) {
    if (reqRelatorioTransacoes !== null) reqRelatorioTransacoes()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/relatorios/transacoes', {
        cancelToken: new CancelToken(function executor(c) {
          reqRelatorioTransacoes = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )
  return retorno
}

export const RelatorioTransacoesPorEC = async parametros => {
  if (reqRelatorioTransacoesPorEC !== null || parametros !== undefined) {
    if (reqRelatorioTransacoesPorEC !== null) reqRelatorioTransacoesPorEC()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/relatorios/por-estabelecimento', {
        cancelToken: new CancelToken(function executor(c) {
          reqRelatorioTransacoesPorEC = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const InformeRendimentos = async parametros => {
  if (reqInformeRendimentos !== null || parametros !== undefined) {
    if (reqInformeRendimentos !== null) reqInformeRendimentos()
    if (parametros.cancelar) return 0
  }

  var CancelToken = axios.CancelToken
  var retorno = ''

  await trackPromise(
    api
      .get('/v1/relatorios/informe-rendimentos', {
        cancelToken: new CancelToken(function executor(c) {
          reqInformeRendimentos = c
        }),
        params: parametros
      })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

/* ------------------------------------ Excel - Exportar ------------------------------------- */

let reqExcelExtratoTransacoes = null;
let reqExcelEstabelecimentosDadosCadastrais = null;
let reqExcelTransacoesFaturamentoPOS = null;
let reqExcelEstabelecimentosMovimentoPOS = null;
let reqExcelDREDistribuidor = null;

/* Excel - Extratos de Transações */
export const ExcelExtratoTransacoes = async (parametros) => {

  if (reqExcelExtratoTransacoes !== null || parametros !== undefined) {
    if (reqExcelExtratoTransacoes !== null) reqExcelExtratoTransacoes();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/relatorios/excel/transacoes", {
      cancelToken: new CancelToken(function executor(c) {
        reqExcelExtratoTransacoes = c;
      }),
      params: parametros
    })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno
}

/* Excel - Extrato de Estabelecimentos - Dados Cadastrais */
export const ExcelEstabelecimentosDadosCadastrais = async (parametros) => {

  if (reqExcelEstabelecimentosDadosCadastrais !== null || parametros !== undefined) {
    if (reqExcelEstabelecimentosDadosCadastrais !== null) reqExcelEstabelecimentosDadosCadastrais();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/relatorios/excel/estabelecimentos/dados-cadastrais", {
      cancelToken: new CancelToken(function executor(c) {
        reqExcelEstabelecimentosDadosCadastrais = c;
      }),
      params: parametros
    })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno
}


/* Excel - Extrato de Transações - Faturamento por POS */
export const ExcelTransacoesFaturamentoPOS = async (parametros) => {

  if (reqExcelTransacoesFaturamentoPOS !== null || parametros !== undefined) {
    if (reqExcelTransacoesFaturamentoPOS !== null) reqExcelTransacoesFaturamentoPOS();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/relatorios/excel/transacoes/faturamento-pos", {
      cancelToken: new CancelToken(function executor(c) {
        reqExcelTransacoesFaturamentoPOS = c;
      }),
      params: parametros
    })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno
}

/* Excel - Extrato de Estabelecimento - Movimento por POS */
export const ExcelEstabelecimentosMovimentoPOS = async (parametros) => {

  if (reqExcelEstabelecimentosMovimentoPOS !== null || parametros !== undefined) {
    if (reqExcelEstabelecimentosMovimentoPOS !== null) reqExcelEstabelecimentosMovimentoPOS();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/relatorios/excel/estabelecimentos/movimento-pos", {
      cancelToken: new CancelToken(function executor(c) {
        reqExcelEstabelecimentosMovimentoPOS = c;
      }),
      params: parametros
    })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno
}

/* Excel - Extrato de Distribuidor  */
export const ExcelDREDistribuidor = async (parametros) => {

  if (reqExcelDREDistribuidor !== null || parametros !== undefined) {
    if (reqExcelDREDistribuidor !== null) reqExcelDREDistribuidor();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/relatorios/excel/distribuidores/dre", {
      cancelToken: new CancelToken(function executor(c) {
        reqExcelDREDistribuidor = c;
      }),
      params: parametros
    })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno
}

let reqExcelContabil = null

/* Excel - Relatório Contábil */
export const ExcelContabil = async (parametros) => {

  if (reqExcelContabil !== null || parametros !== undefined) {
    if (reqExcelContabil !== null) reqExcelContabil();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/relatorios/excel/contabil", {
      cancelToken: new CancelToken(function executor(c) {
        reqExcelContabil = c;
      }),
      params: parametros
    })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno
}

let reqExcelContasPagar = null

/* Excel - Relatório Contábil */
export const ExcelContasPagar = async (parametros) => {

  if (reqExcelContasPagar !== null || parametros !== undefined) {
    if (reqExcelContasPagar !== null) reqExcelContasPagar();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/relatorios/excel/contas-a-pagar", {
      cancelToken: new CancelToken(function executor(c) {
        reqExcelContasPagar = c;
      }),
      params: parametros
    })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno
}

let reqExcelHistoricoDispositivos = null

/* Excel - Histórico de Dispositivos */
export const ExcelHistoricoDispositivos = async (parametros) => {

  if (reqExcelHistoricoDispositivos !== null || parametros !== undefined) {
    if (reqExcelHistoricoDispositivos !== null) reqExcelHistoricoDispositivos();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/relatorios/excel/historico-dispositivos", {
      cancelToken: new CancelToken(function executor(c) {
        reqExcelHistoricoDispositivos = c;
      }),
      params: parametros
    })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

let reqExcelEstabelecimentos = null

export const ExcelEstabelecimentos = async (parametros) => {

  if (reqExcelEstabelecimentos !== null || parametros !== undefined) {
    if (reqExcelEstabelecimentos !== null) reqExcelEstabelecimentos();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/relatorios/excel/estabelecimentos", {
      cancelToken: new CancelToken(function executor(c) {
        reqExcelEstabelecimentos = c;
      }),
      params: parametros
    })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

/* ------------------------------------ Transferências ------------------------------------- */

export const VisualizarTransferencia = async (parametros) => {

  if (reqVisualizarTransferencia !== null || parametros !== undefined) {
    if (reqVisualizarTransferencia !== null) reqVisualizarTransferencia();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/transferencias/visualizar", {
      cancelToken: new CancelToken(function executor(c) {
        reqVisualizarTransferencia = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

export const ListarTransferencias = async (parametros) => {

  if (reqListarTransferencias !== null || parametros !== undefined) {
    if (reqListarTransferencias !== null) reqListarTransferencias();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/transferencias", {
      cancelToken: new CancelToken(function executor(c) {
        reqListarTransferencias = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

export const ResumoTransferencias = async (parametros) => {

  if (reqResumoTransferencias !== null || parametros !== undefined) {
    if (reqResumoTransferencias !== null) reqResumoTransferencias();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/transferencia/resumo", {
      cancelToken: new CancelToken(function executor(c) {
        reqResumoTransferencias = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

/* ------------------------------------ Fluxo de Caixa ------------------------------------- */

export const ContasReceberPagar = async (parametros) => {

  if (reqContasReceberPagar !== null || parametros !== undefined) {
    if (reqContasReceberPagar !== null) reqContasReceberPagar();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("v1/fluxo-caixa/pagar-receber", {
      cancelToken: new CancelToken(function executor(c) {
        reqContasReceberPagar = c;
      }),
      params: parametros
    })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno

}

export const ContasPagarAJ = async (parametros) => {

  if (reqContasReceberAJ !== null || parametros !== undefined) {
    if (reqContasReceberAJ !== null) reqContasReceberAJ();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("v1/fluxo-caixa/analises/contas-pagar/ajustes", {
      cancelToken: new CancelToken(function executor(c) {
        reqContasReceberAJ = c;
      }),
      params: parametros
    })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno

}

export const ContasReceberAJ = async (parametros) => {

  if (reqContasPagarAJ !== null || parametros !== undefined) {
    if (reqContasPagarAJ !== null) reqContasPagarAJ();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("v1/fluxo-caixa/analises/contas-receber/ajustes", {
      cancelToken: new CancelToken(function executor(c) {
        reqContasPagarAJ = c;
      }),
      params: parametros
    })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno

}

export const AnaliseRAV = async (parametros) => {
  if (reqAnaliseRAV !== null || parametros !== undefined) {
    if (reqAnaliseRAV !== null) reqAnaliseRAV();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("v1/fluxo-caixa/analises/rav", {
      cancelToken: new CancelToken(function executor(c) {
        reqAnaliseRAV = c;
      }),
      params: parametros
    })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno
}

export const AnalisePR = async (parametros) => {
  if (reqAnalisePR !== null || parametros !== undefined) {
    if (reqAnalisePR !== null) reqAnalisePR();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("v1/fluxo-caixa/analises/pagamentos-recebimentos", {
      cancelToken: new CancelToken(function executor(c) {
        reqAnalisePR = c;
      }),
      params: parametros
    })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno

}

export const AnaliseMDR = async (parametros) => {
  if (reqAnaliseMDR !== null || parametros !== undefined) {
    if (reqAnaliseMDR !== null) reqAnaliseMDR();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("v1/fluxo-caixa/analises/mdr", {
      cancelToken: new CancelToken(function executor(c) {
        reqAnaliseMDR = c;
      }),
      params: parametros
    })
      .then(response => {
        retorno = response
      })
      .catch(error => {
        retorno = error.response
      })
  )

  return retorno

}

/* ------------------------------------ Financeiro ------------------------------------- */
let reqListarRecebimentos = null
let reqListarAgendaFutura = null
let requestFinanceiroAntecipacoes = null
let requestSolicitarAntecipacao = null
let requestListarSolicitacoes = null
let requestVisualizarSolicitacoes = null
let requestFinanceiroAntecipacoesCancelarSpot = null

export const ListarPagamentos = async (parametros) => {

  if (reqListarPagamentos !== null || parametros !== undefined) {
    if (reqListarPagamentos !== null) reqListarPagamentos();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/financeiro/" + parametros.tipo, {
      cancelToken: new CancelToken(function executor(c) {
        reqListarPagamentos = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

export const ListarRecebimentos = async (parametros) => {

  if (reqListarRecebimentos !== null || parametros !== undefined) {
    if (reqListarRecebimentos !== null) reqListarRecebimentos();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/financeiro/recebiveis/liquidados", {
      cancelToken: new CancelToken(function executor(c) {
        reqListarRecebimentos = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

export const ListarAgendaFutura = async (parametros) => {

  if (reqListarAgendaFutura !== null || parametros !== undefined) {
    if (reqListarAgendaFutura !== null) reqListarAgendaFutura();
    if (parametros.cancelar) return 0;
  }

  var CancelToken = axios.CancelToken;
  var retorno = '';

  await trackPromise(
    api.get("/v1/financeiro/recebiveis/agenda-futura", {
      cancelToken: new CancelToken(function executor(c) {
        reqListarAgendaFutura = c;
      }),
      params: parametros
    }).then(response => {
      retorno = response
    })
      .catch(error => {
        retorno = error.response
      })
  );

  return retorno

}

export const FinanceiroAntecipacoes = async parametros => {
	if (requestFinanceiroAntecipacoes !== null || parametros !== undefined) {
		if (requestFinanceiroAntecipacoes !== null) requestFinanceiroAntecipacoes();
		if (parametros.cancelar) return 0;
	}

	var CancelToken = axios.CancelToken;
	var retorno = '';

	await trackPromise(
		api
			.get('/v1/antecipacoes', {
				cancelToken: new CancelToken(function executor(c) {
					requestFinanceiroAntecipacoes = c;
				}),
				params: parametros
			})
			.then(response => {
				retorno = response;
			})
			.catch(error => {
				retorno = error.response;
			})
	);

	return retorno;
};

export const SolicitarAntecipacao = async (parametros) => {

	if (requestSolicitarAntecipacao !== null || parametros !== undefined) {
		if (requestSolicitarAntecipacao !== null) requestSolicitarAntecipacao();
		if (parametros.cancelar) return 0;
	}

	var CancelToken = axios.CancelToken;
	var retorno = '';

	await trackPromise(
		api.post("/v1/antecipacoes/solicitar", {
			cancelToken: new CancelToken(function executor(c) {
				requestSolicitarAntecipacao = c;
			}),
			...parametros
		})
			.then(response => {
				retorno = response
			})
			.catch(error => {
				retorno = error.response
			})
	);

	return retorno

}

export const ListarSolicitacoesAntecipacoes = async (parametros) => {

	if (requestListarSolicitacoes !== null || parametros !== undefined) {
		if (requestListarSolicitacoes !== null) requestListarSolicitacoes();
		if (parametros.cancelar) return 0;
	}

	var CancelToken = axios.CancelToken;
	var retorno = '';

	await trackPromise(
		api.get("/v1/antecipacoes/listar", {
			cancelToken: new CancelToken(function executor(c) {
				requestListarSolicitacoes = c;
			}),
			params: parametros,
		})
			.then(response => {
				retorno = response
			})
			.catch(error => {
				retorno = error.response
			})
	);

	return retorno

}

export const VisualizarSolicitacoes = async (parametros) => {

	if (requestVisualizarSolicitacoes !== null || parametros !== undefined) {
		if (requestVisualizarSolicitacoes !== null) requestVisualizarSolicitacoes();
		if (parametros.cancelar) return 0;
	}

	var CancelToken = axios.CancelToken;
	var retorno = '';

	await trackPromise(
		api.get("/v1/antecipacoes/visualizar", {
			cancelToken: new CancelToken(function executor(c) {
				requestVisualizarSolicitacoes = c;
			}),
			params: parametros,
		})
			.then(response => {
				retorno = response
			})
			.catch(error => {
				retorno = error.response
			})
	);

	return retorno

}

export const FinanceiroAntecipacoesCancelarSpot = async parametros => {
	if (requestFinanceiroAntecipacoesCancelarSpot !== null || parametros !== undefined) {
		if (requestFinanceiroAntecipacoesCancelarSpot !== null) requestFinanceiroAntecipacoesCancelarSpot();
		if (parametros.cancelar) return 0;
	}

	var CancelToken = axios.CancelToken;
	var retorno = '';

	await trackPromise(
		api
			.post('/v1/antecipacoes/cancelar', {
				cancelToken: new CancelToken(function executor(c) {
					requestFinanceiroAntecipacoesCancelarSpot = c;
				}),
				solicitation_key: parametros.solicitation_key,
				merchants_id: parametros.merchants_id
			})
			.then(response => {
				retorno = response;
			})
			.catch(error => {
				retorno = error.response;
			})
	);

	return retorno;
};

/* ------------------------------------ Outros ------------------------------------- */

export const buscaEndereco = async (parametros) => {

	if (requestBuscaEndereco !== null || parametros !== undefined) {
		if (requestBuscaEndereco !== null) requestBuscaEndereco();
		if (parametros.cancelar) return null;
	}

	var CancelToken = axios.CancelToken;
	var retorno = '';

	await trackPromise(
		api.get("/v1/consultas/correios/endereco/", {
			cancelToken: new CancelToken(function executor(c) {
				requestBuscaEndereco = c;
			}),
			params: parametros
		}).then(response => {
			retorno = response
		})
			.catch(error => {
				retorno = error.response
			})
	);

	return retorno

}

/* ------------------------------------ Relatórios API Arquivos ------------------------------------- */


export const SolicitarRelatorio = async (parametros) => {

	if (requestSolicitarRelatorio !== null || parametros !== undefined) {
		if (requestSolicitarRelatorio !== null) requestSolicitarRelatorio();
		if (parametros.cancelar) return 0;
	}

	var CancelToken = axios.CancelToken;
	var retorno = ''

	await trackPromise(
		apiArquivos[parametros?.route_method ?? 'post'](`/v3/relatorios/vendors/${parametros.route_path}`, {
      ...parametros,
			cancelToken: new CancelToken(function executor(c) {
				requestSolicitarRelatorio = c;
			}),
		})
			.then(response => {
				retorno = response
			})
			.catch(error => {
				retorno = error.response
			})
	);

	return retorno

}


export const RequestApiReports = async (parametros) => {

	if (requestApiReports !== null || parametros !== undefined) {
		if (requestApiReports !== null) requestApiReports();
		if (parametros.cancelar) return 0;
	}

	var CancelToken = axios.CancelToken;
	var retorno = ''

	await trackPromise(
		apiReports.post(`/${parametros.route_path}`, {
      ...parametros,
			cancelToken: new CancelToken(function executor(c) {
				requestApiReports = c;
			}),
		})
			.then(response => {
				retorno = response
			})
			.catch(error => {
				retorno = error.response
			})
	);

	return retorno

}

export const ListarRelatoriosSolicitados = async (parametros) => {

	if (requestRelatoriosSolicitados !== null || parametros !== undefined) {
		if (requestRelatoriosSolicitados !== null) requestRelatoriosSolicitados();
		if (parametros.cancelar) return 0;
	}

	var CancelToken = axios.CancelToken;
	var retorno = '';

	await trackPromise(
		api.get("/v1/arquivos/solicitados", {
			cancelToken: new CancelToken(function executor(c) {
				requestRelatoriosSolicitados = c;
			}),
			params: parametros
		}).then(response => {
			retorno = response
		})
			.catch(error => {
				retorno = error.response
			})
	);

	return retorno

}
